<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="账号">
        <el-input v-model="queryForm.userName" placeholder="请输入账号"></el-input>
      </el-form-item>
       <el-form-item label="手机号">
        <el-input v-model="queryForm.userPhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getUserList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
        <!-- 新增按钮 -->
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addWarningPerson"
          >新建</el-button>
        </div>
        <div>点击查询展示数据</div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshWarningPersonList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="warningPersonList"
        row-key="id"
        size="small"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userName"
          label="账号"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userPhone"
          label="手机号"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="money"
          label="充值金额"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="20%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="deleteShopBrand(scop.row.id)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增预警人员弹框 -->
      <el-dialog
        title="新增预警人员"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="warningPersonForm"
            ref="warningPersonForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="small"
          >
            <el-form-item
              label="用户"
              prop="userPhone"
            >
              <GridSelect
                style='width: 177px'
                title='选择用户'
                labelName='userName'
                labelValue='id'
                :value='warningPersonForm.userId'
                :limit='1'
                size='small'
                placeholder='请选择用户'
                @getValueAll="getValueFn"
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl='/mpp/user/findList'
                entityBeanName='mppUser'
                queryEntityUrl='/mpp/user/get'
            >
            </GridSelect>
            </el-form-item>
            <el-form-item
              label="手机号"
              prop="userPhone"
            >
              <el-input
                size="small"
                style="width: 180px"
                :value="warningPersonForm.userPhone"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="充值金额"
              prop="money"
            >
              <!-- <el-input
                  size="small"
                  style='width: 177px'
                  :value="formattedMoney"
                  @input="handleMoneyInput"
              ></el-input> -->
              <el-input
                  size="small"
                  style='width: 177px'
                  v-model="displayValue"
                  @input="handleInput"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search, Disabled } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    data() {
        return {
            queryForm: {
                userName: '',
                userPhone: ''
            },
            loading: false,
            showDialog: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            warningPersonList: [],
            warningPersonForm: {
                userId: '',
                userPhone: '',
                money: ''
            },
            rules: {
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                brandLogo: [{ required: true, message: '品牌Logo不能为空', trigger: 'blur' }]
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            displayValue:''
        };
    },
    created() {
        // this.getUserList();
    },
    methods: {
      
        // 处理输入事件
        handleInput(value) {
            // 移除所有非数字字符（除了小数点和负号）
            let numStr = value.replace(/[^0-9.-]/g, '')
            
            // 处理多个小数点的情况
            const decimalParts = numStr.split('.')
            if (decimalParts.length > 2) {
                numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`
            }
            
            // 处理负号不在开头的情况
            if (numStr.includes('-') && !numStr.startsWith('-')) {
                numStr = numStr.replace(/-/g, '')
                numStr = '-' + numStr
            }
            
            this.warningPersonForm.money = numStr;
            // 格式化显示值
            this.displayValue = this.formatNumberNew(numStr)
        },
        // 格式化数字为千分位
        formatNumberNew(value) {
            if (value === '' || value === null || value === undefined) return ''
            
            // 转换为字符串并移除所有非数字字符（除了小数点和负号）
            let numStr = String(value).replace(/[^0-9.-]/g, '')
            
            // 处理多个小数点的情况
            const decimalParts = numStr.split('.')
            if (decimalParts.length > 2) {
                numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`
            }
            
            // 处理负号不在开头的情况
            if (numStr.includes('-') && !numStr.startsWith('-')) {
                numStr = numStr.replace(/-/g, '')
                numStr = '-' + numStr
            }
            
            // 分割整数和小数部分
            const parts = numStr.split('.')
            let integerPart = parts[0]
            const decimalPart = parts.length > 1 ? `.${parts[1]}` : ''
            
            // 添加千分位分隔符（跳过负号）
            if (integerPart) {
                const isNegative = integerPart.startsWith('-')
                const numWithoutSign = isNegative ? integerPart.slice(1) : integerPart
                const formatted = numWithoutSign.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                integerPart = isNegative ? `-${formatted}` : formatted
            }

            return '$ ' + integerPart + decimalPart
        },
        // 新增弹框选择用户的时候回填手机号
        getValueFn(val){
          this.warningPersonForm.userId = val.id
          this.warningPersonForm.userPhone = val.userMobile
        },
        // 是否展示搜索项
        search() {
            this.isSearch = !this.isSearch;
        },
        // 获取列表数据
        getUserList() {
            this.loading = true;
            get(`/moneyRecord/user/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success && res.page) {
                    this.warningPersonList = res.page.list || [];
                    this.totalNum = res.page.total || 0;
                }
            });
        },
        // 清空搜索信息
        resetQueryFrom() {
            this.queryForm.userName = '';
            this.queryForm.userPhone = '';
            this.getUserList();
        },
        // 重置列表数据
        resetWarningPersonList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.warningPersonList = [];
        },
        // 删除
        deleteShopBrand(id) {
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                get(`/moneyRecord/user/updateById`, { id:id }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                        this.resetWarningPersonList();
                        this.getUserList();
                    }
                });
            })
            .catch(() => {});
        },
         // 打开新增弹框
        addWarningPerson() {
            this.showDialog = true;
        },
        // 关闭弹框
        closeDialog() {
            this.resetDialog();
            this.$refs.warningPersonForm.resetFields();
        },
        // 清空弹框数据
        resetDialog() {
            this.showDialog = false;
            this.warningPersonForm = {
                userId: '',
                userPhone: '',
                money: ''
            };
            this.displayValue = '';
            this.getUserList();
        },
        // 弹框提交
        submitForm() {
            this.$refs.warningPersonForm.validate((valid) => {
                if (valid) {
                    post(`/moneyRecord/user/add`, { ...this.warningPersonForm }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetWarningPersonList();
                            this.closeDialog();
                        }
                    });
                }
            });
        },
        // 刷新列表数据
        refreshWarningPersonList() {
            this.resetWarningPersonList();
            this.getUserList();
        },
        // 当前页码更改
        currentChange(page) {
            this.currentPage = page;
            this.getUserList();
        },
        // 查询条数更改
        sizeChange(size) {
            this.pageSize = size;
            this.getUserList();
        }
    }
};
</script>

<style lang="scss" scoped>

.page-content{
    height: 100%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
